export default "__VITE_ASSET__359a4305__"